import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getTablesEfficiencyDataRequest = (
  token,
  date,
  selectedRestaurant,
  startTime,
  endTime
) => {
  const organizationId = localStorage.getItem("organizationId");

  let url =
    apiURl +
    "tables/Efficiency?organizationId=" +
    organizationId +
    "&restaurantId=" +
    selectedRestaurant +
    "&date=" +
    date;

  if (startTime && endTime) {
    url += `&startTime=${startTime}&endTime=${endTime}`;
  }

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getTablesEfficiencyDataRequest };
